import { ActivFitnessTheme } from './activ-fitness';
import { AlnaturaTheme } from './alnatura';
import { AusDerRegionTheme } from './aus-der-region';
import { BernaquaTheme } from './bernaqua';
import { BikeworldTheme } from './bikeworld';
import { DennerTheme } from './denner';
import { DoitGardenTheme } from './doitgarden';
import { ExlibrisTheme } from './exlibris';
import { ExlibrisPickMupTheme } from './exlibris-pickmup';
import { FamigrosTheme } from './famigros';
import { FitnessparkTheme } from './fitnesspark';
import { GastroTheme } from './gastro';
import { GesundheitsplattformTheme } from './gesundheitsplattform';
import { IciTheme } from './ici';
import { KlubschuleTheme } from './klubschule';
import { MelectronicsTheme } from './melectronics';
import { MgbTheme } from './mgb';
import { MicasaTheme } from './micasa';
import { migipediaTheme } from './migipedia';
import { migipediaDarkTheme } from './migipedia-dark';
import { MigrolTheme } from './migrol';
import { MigrosAppTheme } from './migros-app';
import { MigrosCorporateTheme } from './migros-corporate';
import { MigrosEngagementTheme } from './migros-engagement';
import { MigrosEngagementSmallTheme } from './migros-engagement-small';
import { MigrosFitnessTheme } from './migros-fitness';
import { MigrosServiceTheme } from './migros-service';
import { MigrosAccountTheme } from './migrosaccount';
import { MigrosbankTheme } from './migrosbank';
import { MigustoTheme } from './migusto';
import { PickmupTheme } from './pickmup';
import { RialtoTheme } from './rialto';
import { SportxxTheme } from './sportxx';
import { SwissFitTheme } from './swissfit';
import { VoiTheme } from './voi';
import { MigrosOnlineTheme } from './migros-online';
import { MigrosCampaignSummerTheme } from './migros-campaign-summer';
const themes = {
  mgb: MgbTheme,
  migrosCorporate: MigrosCorporateTheme,
  bikeworld: BikeworldTheme,
  doitGarden: DoitGardenTheme,
  klubschule: KlubschuleTheme,
  melectronics: MelectronicsTheme,
  micasa: MicasaTheme,
  migipedia: migipediaTheme,
  migipediaDark: migipediaDarkTheme,
  migusto: MigustoTheme,
  migrosService: MigrosServiceTheme,
  rialto: RialtoTheme,
  sportxx: SportxxTheme,
  migrosApp: MigrosAppTheme,
  alnatura: AlnaturaTheme,
  ausDerRegion: AusDerRegionTheme,
  exlibris: ExlibrisTheme,
  exlibrispickmup: ExlibrisPickMupTheme,
  gesundheitsplattform: GesundheitsplattformTheme,
  famigros: FamigrosTheme,
  migrosbank: MigrosbankTheme,
  pickmup: PickmupTheme,
  voi: VoiTheme,
  fitnesspark: FitnessparkTheme,
  migrosFitness: MigrosFitnessTheme,
  migrosaccount: MigrosAccountTheme,
  bernaqua: BernaquaTheme,
  activFitness: ActivFitnessTheme,
  gastro: GastroTheme,
  ici: IciTheme,
  migrosEngagement: MigrosEngagementTheme,
  migrosEngagementSmall: MigrosEngagementSmallTheme,
  denner: DennerTheme,
  swissfit: SwissFitTheme,
  migrol: MigrolTheme,
  migrosOnline: MigrosOnlineTheme,
  migrosCampaignSummer: MigrosCampaignSummerTheme
};
export function getTheme(key) {
  return themes[key] || {};
}
export const possibleThemes = Object.keys(themes);